import {TradingAlgorithmBacktestStreamingResponse, TradingBacktestResult, TradingPortfolio} from "./typesTrading";

export enum MessageType {
    Hello = "hello",
    BacktestBegin = "backtest_begin",
    BacktestInterval = "backtest_interval",
    BacktestStop = "backtest_stop",
    ClientPricesRequest = "client_prices_request",
    ClientPositionChangeRequest = "client_position_change_request",
}

export interface ClientPricesRequest {
    current_date: string; // ISO date
    tickers: string[];
}

export interface ServerPriceResponse {
    ticker_prices: [string, number][];
}

export interface ServerBacktestIntervalRequest {
    current_date: string; // ISO date
}

export interface ClientPositionChange {
    trade_date: string; // ISO date
    ticker: string;
    price: number;
    action: "BUY" | "SELL";
    shares: number;
}

export interface ClientPositionChanges {
    position_changes: ClientPositionChange[];
}

type MessageData =
    | ClientPricesRequest
    | ServerPriceResponse
    | ServerBacktestIntervalRequest
    | ClientPositionChanges
    | TradingAlgorithmBacktestStreamingResponse
    | TradingBacktestResult
    | Record<string, unknown>
    | null;

export interface StreamingData {
    session_id: string;
    message_type: MessageType;
    message_data?: MessageData;
}


export interface BacktestCancelHandle {
    cancelled: boolean;
    close: () => void;
}
